import { RouterConfig } from "@shared/lib/routerConfig";

export const menuItems = [
    { title: "Автомобили", link: RouterConfig.CATALOG_ALL },
    { title: "Оценка авто", link: RouterConfig.ANALYTICS },
    { title: "Блог", link: RouterConfig.BLOG },
    { title: "Страхование", link: RouterConfig.INSURANCE },
    { title: "Документы", link: RouterConfig.GENERATOR_DKP },
    {
        title: "Сервисы",
        children: [
            { title: "Обслуживание авто", externalLink: "https://new-service.uremont.com" },
            { title: "Аукцион", externalLink: "https://www.migtorg.com" }
        ]
    }
];